import React from 'react'
import PropTypes from 'prop-types'
import theme from '../../theme'

// material components
import Typography from '@mui/material/Typography'
import MoreVertIcon from '@mui/icons-material/MoreVert'
//import { TimePicker as TPicker } from 'material-ui-pickers'
//import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';


// application
import Ax from '../../hoc/Ax/Ax'

const styles = {
    label: {
        marginTop: 5,
        color: theme.palette.secondary.dark,
    },
    icon: {
        color: theme.palette.primary.dark,
    },
}

/**
 * component for sidebar
 * @param classes
 * @param value
 * @param label
 * @param timePickerChange
 * @returns {*}
 * @constructor
 */
const TimePicker = ({ classes, value, label, timePickerChange }) => (
    <Ax>
       {/*  <TPicker
            style={{ width: '100%', color:theme.palette.primary.dark }}
            ampm={false}
            keyboard
            autoOk={false}
            format="HH:mm 'Uhr'"
            value={value}
            onChange={time => timePickerChange(time)}
            keyboardIcon={<MoreVertIcon style={styles.icon}/>}
        /> */}
        {(label)
        && (<Typography variant={'caption'} style={styles.label}>
            {label}
        </Typography>)}
    </Ax>
)


TimePicker.defaultProps = {
    value: new Date(),
    label: false,
}

TimePicker.propTypes = {
    timePickerChange: PropTypes.func.isRequired,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
}

export default TimePicker
